// extracted by mini-css-extract-plugin
export default {"badge":"r1_Hf","small":"MZaMe","medium":"V4HOR","large":"eJVxi","primary":"bdWoc","secondary":"efc_o"};